import axios from 'axios'
// import apiClient from './apiClient'
import Cookies from 'js-cookie'

export const BASE_URL = 'https://vidyabhartiapi.virtualprachar.com/api'
export const BASE_URL_Upload = 'https://vidyabhartiapi.virtualprachar.com'

const apiClient = axios.create({
  baseURL: BASE_URL,
  // headers: {
  //   'Content-Type': 'application/json',
  //   Accept: 'application/json',
  // },
})

apiClient.interceptors.request.use(
  (config) => {
    try {
      const userCookie = Cookies.get('user')
      if (userCookie) {
        const user = JSON.parse(userCookie)

        if (user.token) {
          config.headers['Authorization'] = `Bearer ${user.token}`
          console.log('🔐 Token:', user.token)
        }

        // if (user.institute_id) {
        //   config.headers['institute_id'] = user.institute_id
        //   console.log('🏫 Institute ID:', user.institute_id)
        // }

        if (user.name) {
          config.headers['name'] = user.name
          console.log('🏷️ Institute Name:', user.name)
        }

        // Optional: log entire headers for debug
        // console.log('📦 Final Headers Sent:', config.headers)
      } else {
        console.warn('⚠️ No user cookie found')
      }

      return config
    } catch (err) {
      console.error('❌ Error parsing user cookie:', err)
      return config // allow request even if cookie parsing fails
    }
  },
  (error) => {
    console.error('❌ Request Interceptor Error:', error)
    return Promise.reject(error)
  },
)

const ApiEndpoints = {
  signUp: (signupData) => apiClient.post('/signup', signupData),
  login: (loginUser) => apiClient.post('/login', loginUser),

  // Dashboard
  getDashboardData: () => apiClient.get('/dashboard'),
  getFeesByMonths: () => apiClient.get('/dashboard/fees-by-months'),
  getStudentCount: () => apiClient.get('dashboard/students-count'),
  getCourseCount: () => apiClient.get('students/count-by-course'),

  getAllStudents: () => apiClient.get('/student/all'),
  addStudent: (studentData) => apiClient.post('/student/add', studentData),
  // addStudentImage: (studentImage) =>
  //   apiClient.post('/upload-image', studentImage),

  editStudent: (id, studentData) =>
    apiClient.put(`/student/${id}`, studentData),
  viewProfile: (id) => apiClient.get(`/student/${id}`),
// viewProfile: (id, headers = {}) => {
//   const instituteId = Cookies.get('institute_id')
//   return apiClient.get(`/student/${id}`, {
//     headers: {
//       institute_id: Number(instituteId),
//     },
//   })
// },

  // getAllCourses: () => apiClient.get('/course/all'),
  getAllCourses: () => {
    const institueId = Cookies.get('institute_id')
    console.log('INStitute ID:', institueId)
    // const headers = {
    //   institute_id: Number(institueId),
    // }
    // return apiClient.get('/course/all', { headers })
    return apiClient.get('/course/all', {
      headers: {
        institute_id: Number(institueId),
      },
    })
  },
  // addCourse: (courseData, instituteId) =>
  //   apiClient.post('/course/add', courseData, {
  //     headers: {
  //       institute_id: instituteId,
  //     },
  //   }),
  // getAllCourses: () => {
  //   const instituteId = Cookies.get('institute_id')

  //   if (!instituteId) {
  //     console.warn('Institute ID is missing. No API call will be made.')
  //     return Promise.resolve({ data: { data: [] } }) // Return empty course list safely
  //   }

  //   return apiClient.get('/course/all', {
  //     headers: {
  //       institute_id: Number(instituteId),
  //     },
  //   })
  // },

  addCourse: (courseData, instituteId) => {
    console.log('Adding course for institute:', instituteId)
    return apiClient.post('/course/add', {
      ...courseData,
      institute_id: Number(instituteId),
    })
  },

  editCourse: (id, courseData) =>
    apiClient.put(`/course/edit/${id}`, courseData),

  // getAllClasses: () => apiClient.get('/class/all'),
  getAllClasses: () => {
    const institueId = Cookies.get('institute_id')
    console.log('🏫 Institute ID for class:', institueId)
    return apiClient.get('/class/all', {
      headers: {
        institute_id: Number(institueId),
      },
    })
  },
  
//   getAllClasses: (instituteIdParam) => {
//   // 1. Try direct cookie (works for admin)
//   let instituteId = Cookies.get('institute_id') || instituteIdParam

//   // 2. If not found, try parsing from "user" cookie (for teacher)
//   if (!instituteId) {
//     const userCookie = Cookies.get('user')
//     if (userCookie) {
//       try {
//         const user = JSON.parse(userCookie)
//         instituteId = user.institute_id
//       } catch (err) {
//         console.error("❌ Failed to parse user cookie:", err)
//       }
//     }
//   }

//   console.log('🏫 Institute ID for class:', instituteId)

//   // 3. If still missing, warn and return fallback request
//   if (!instituteId) {
//     console.warn("⚠️ No institute_id found. Sending request without it.")
//     return apiClient.get('/class/all')
//   }

//   // 4. Send with proper header
//   return apiClient.get('/class/all', {
//     headers: {
//       institute_id: Number(instituteId),
//     },
//   })
// },

  addClass: (classData) => apiClient.post('/class/add', classData),
  editClass: (id, studentData) =>
    apiClient.put(`/class/edit/${id}`, studentData),
  getAllClassesByCourseId: (classCourseId) =>
    apiClient.get(`/get/classes/by/${classCourseId}`),

  getAllInstitutes: () => apiClient.get('/institute/all'),
  addInstitute: (instituteData) =>
    apiClient.post('/institute/add', instituteData),
  editInstitute: (id, instituteData) =>
    apiClient.put(`/institute/${id}`, instituteData),
  // getAllInstituteById: (institueId) =>
  //   apiClient.get(`/institute/${institueId}`),

  getAllSubjects: () => apiClient.get('/subject/all'),
  getSubjectsByCourse: (course_id, data) =>
    apiClient.get(`/get/subjects/by-course?course_id=${course_id}`, data),

  addSubject: (subjectData) => apiClient.post('/subject/add', subjectData),
  editSubject: (id, subjectData) =>
    apiClient.put(`/subject/edit/${id}`, subjectData),

  getAllTeachers: (headers = {}) => apiClient.get('/teacher/all', { headers }),
  addTeacher: (teachersData) => apiClient.post('/teacher/add', teachersData),
  editTeacher: (id, teachersData) =>
    apiClient.put(`/teacher/${id}`, teachersData),
  addAssignClass: (assignClass) => apiClient.post('/assign-class', assignClass),
  getAllAssignedClasses: (assignedClasses) =>
    apiClient.get(`/teacher-classes/${assignedClasses}`),
  editAssignClassTeacher: (id, assignData, config) =>
    apiClient.put(`/update-assignment/${id}`, assignData, config),

  addParent: (parentData) => apiClient.post('/add/guardian', parentData),

  // getAllEnquiries: () => apiClient.get('/enquiries/all'),
  // addEnquiry: (enquiriesData) => apiClient.post('/enquiry/add', enquiriesData),
  getAllEnquiries: () => {
    const institueId = Cookies.get('institute_id')
    console.log('INStitute ID:', institueId)
    return apiClient.get('/enquiries/all', {
      headers: {
        institute_id: Number(institueId),
      },
    })
  },
  // addEnquiry: (enquiryData, token) => {
  //   console.log('Adding enquiry for institute:', instituteId)
  //   return apiClient.post('/enquiry/add', {
  //     ...enquiryData,
  //     institute_id: Number(instituteId),
  //   })
  // },
  // editEnquiry: (id, enquiriesData, headers) =>
  //   apiClient.put(`/enquiry/${id}`, enquiriesData, { headers }),
  addEnquiry: (enquiryData, token) => {
    return apiClient.post('/enquiry/add', enquiryData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },
  addMarketer: (marketer) => apiClient.post('/add/marketer', marketer),

  getAllFees: () => apiClient.get('/fee/structure/get/all'),
  addFee: (feeData) => apiClient.post('/fee/structure/add', feeData),
  addStudentApplyFees: (studentApplyFessData) =>
    apiClient.post('/student/apply/fees', studentApplyFessData),
  submitStudentFee: (submitStudentFee) =>
    apiClient.post('/submit-student-fee', submitStudentFee),
  getAllFeesByStudentId: (student_id, course_id) =>
    apiClient.get(
      `/fees/student?student_id=${student_id}&course_id=${course_id}`,
    ),
  getAllFeesByStudentProfileId: (student_id) =>
    apiClient.get(`/get/all/fee/by/${student_id}`),

  getAllFeeCollection: () => apiClient.get('/fee-collection'),

  getAllExam: () => apiClient.get('/get/exam/all'),
  addExam: (examData) => apiClient.post('/exam/add', examData),
  editExam: (id, examData) => apiClient.put(`/update/exam/${id}`, examData),
  cancelExamById: (id) => apiClient.post(`/exam/cancel/${id}`),

  addStudentExamResult: (studentExamData) =>
    apiClient.post('/add/student/result', studentExamData),
  getStudentExamMarks: (student_id, course_id) =>
    apiClient.get(`/student/results/${student_id}/${course_id}`),

  addAttendance: (studentAttendance) =>
    apiClient.post('/attendance', studentAttendance),
  getAllAttendance: (payload) => apiClient.post('/get/attendance', payload),

  getFeeReciept: (receiptById) => apiClient.get(`/get/fees/${receiptById}`),
  addConfig: (configData) => apiClient.post('/create-setting', configData),
  editConfig: (id, configData) =>
    apiClient.post(`/update-setting/${id}`, configData),

  getSession: () =>
    apiClient.get(`/get/session`),

}

export default ApiEndpoints
